
import { HTMLBars } from "./BarCharts/HTMLBars";
import { LineCharts } from "./LineCharts/LineCharts";
 
import { PieChart } from "./PieChart/PieChart";

export const chart_types = {
  line: LineCharts,
 
  bar: HTMLBars,
  pie: PieChart,
}